import moment from 'moment';

export const momentDates = data => {
    if (Array.isArray(data)) return data.map(momentDates);

    let dto = {
        ...data,
        dateDebut: moment(data.dateDebut.date)
    };

    if (data.dateFin && data.dateFin.date) dto.dateFin = moment(data.dateFin.date);

    return dto;
};

export default {momentDates};